import { meta } from "@/lib/status";

export function StatusBadge({ status, size = "sm", testId }) {
  const m = meta(status);
  const Icon = m.icon;
  const pad = size === "lg" ? "px-3 py-1.5 text-sm" : "px-2.5 py-1 text-xs";
  return (
    <span
      data-testid={testId || `status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full border font-semibold ${pad} ${m.cls}`}
    >
      <Icon className="h-3.5 w-3.5" strokeWidth={2.5} />
      {m.label}
    </span>
  );
}
